import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuname: "index",
    topHeight: 0,
  },
  mutations: {
    changeMenuName(state, name) {
      state.menuname = name;
    },
    setTopHeight(state, payload) {
      state.topHeight = payload.h;
    },
  },
  actions: {},
});
